// Widths of the actual containers. `Image` runs in `fill` mode, which without
// `sizes` would build a srcset from 100vw and download far more than needed.
export const MOBILE_BANNER_SIZES =
  "(max-width: 767px) calc(100vw - 20px), 428px"
export const FEATURED_BANNER_SIZES = "428px"
export const COMPACT_BANNER_SIZES =
  "(max-width: 1439px) calc(100vw - 464px), 240px"
